export default "__VITE_ASSET__BcvWVeEw__"